import { render, staticRenderFns } from "./MessageShow.vue?vue&type=template&id=39d124a0"
import script from "./MessageShow.vue?vue&type=script&lang=ts"
export * from "./MessageShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports